<template>
  <div class="box">
    <div class="loading-spinner-outer" v-if="loading">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
      </div>
    </div>
    <div class="box-content flex-stretch relative">
      <div style="position: absolute; top:0; left:0; right: 0; bottom: 0; background:white; opacity: 0.8; z-index: 1;" v-show="filtering"></div>
      <div class="flex justify-end mb-3">
        <div>
          <reports-menu></reports-menu>
        </div>
      </div>
      <table class="table _lined">
        <thead>
        <tr>
          <th>
            System
          </th>
          <th>
            Total Companies
          </th>
          <th>
            Total Users
          </th>
          <th>
            Activated Users
          </th>
          <th>
            Unactivated Users
          </th>
        </tr>
        </thead>
        <tr v-for="company_system_count in company_system_counts">
          <td>
            {{ company_system_count.system_type_label }}
          </td>
          <td>
            {{ company_system_count.company_count }}
          </td>
          <td>
            {{ company_system_count.user_count }}
          </td>
          <td>
            {{ company_system_count.activated_user_count }}
          </td>
          <td>
            {{ company_system_count.unactivated_user_count }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  async mounted() {
    this.loadCompanySystemCounts();
  },
  props: [
  ],
  components: {
    'datepicker': Datepicker,
  },
  data() {
    return {
      filtering: false,
      date_filter_start: null,
      date_filter_end: new Date(),
      company_system_counts: [],
      loading: true,
    }
  },
  methods: {
    loadCompanySystemCounts: _.debounce(function () {
      axios.post('/reports/getCompanySystemCountData').then((response) => {
        this.company_system_counts = response.data;
        this.loading = false;
        this.filtering = false;
      });
    }, 250),
  },
  watch: {
  },
};
</script>
